<template>
  <b-row v-if="sales_products_context_loaded" class="white-box m-0 mr-2 ml-2">
    <b-col xl="2" lg="12" order="2" order-xl="1" align-self="center">
      <b-row>
        <b-col>
          <medium-button id="sales-button-1" text="consolidado" class="active" @onClick="toogleChart('consolidated')">
          <svg slot="svg" xmlns="http://www.w3.org/2000/svg" width="26.624" height="26.624" viewBox="0 0 26.624 26.624">
            <g transform="translate(-868.598 -511.21)" clip-path="url(#a)">
              <rect width="25.106" height="25.106" rx="2.058" transform="translate(869.357 511.96)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
              <line y2="5.589" transform="translate(875.934 515.75)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
              <line x2="5.589" transform="translate(873.139 518.545)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
              <line x2="5.589" transform="translate(885.405 518.545)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
              <line x2="5.589" transform="translate(885.63 529.08)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
              <line x2="5.589" transform="translate(885.63 532.635)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
              <line x2="3.952" y2="3.952" transform="translate(873.957 528.834)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
              <line x1="3.952" y2="3.952" transform="translate(873.957 528.834)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
              <line y2="25.124" transform="translate(881.91 511.96)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
              <line x1="25.124" transform="translate(869.348 524.522)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
            </g>
          </svg>
          </medium-button>
          <medium-button text="vendas diárias" @onClick="toogleChart('daily')">
          <svg slot="svg" xmlns="http://www.w3.org/2000/svg" width="24.047" height="23.507" viewBox="0 0 24.047 23.507">
            <defs>
              <clipPath id="b">
                <rect width="24.047" height="23.507" fill="none"/>
              </clipPath>
            </defs>
            <g transform="translate(0)" clip-path="url(#b)">
              <line y2="22.007" transform="translate(0.75 0.75)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
              <path d="M577.194,518.6l-9.043,2.589-1.722,5.6-6.244,1.592-4.522,6.988h21.531" transform="translate(-554.913 -512.615)" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
              <path d="M587.322,519.982l1.392-2.245-2.076-1.278" transform="translate(-565.417 -511.887)" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
            </g>
          </svg>
          </medium-button>
        </b-col>
        <b-col>
          <medium-button text="vendas mensais" @onClick="toogleChart('monthly')">
            <svg slot="svg" xmlns="http://www.w3.org/2000/svg" width="24.047" height="23.507" viewBox="0 0 24.047 23.507">
              <defs>
                <clipPath id="c">
                  <rect width="24.047" height="23.507" fill="none"/>
                </clipPath>
              </defs>
              <g transform="translate(0)" clip-path="url(#c)">
                <line y2="22.007" transform="translate(0.75 0.75)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                <path d="M577.194,518.6l-9.043,2.589-1.722,5.6-6.244,1.592-4.522,6.988h21.531" transform="translate(-554.913 -512.615)" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                <path d="M587.322,519.982l1.392-2.245-2.076-1.278" transform="translate(-565.417 -511.887)" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
              </g>
            </svg>
          </medium-button>
          <medium-button v-if="channels_data.length > 1" text="pedidos por canal" @onClick="toogleChart('channel')">
            <svg slot="svg" xmlns="http://www.w3.org/2000/svg" width="24.047" height="27.389" viewBox="0 0 24.047 27.389">
              <defs>
                <clipPath id="d">
                  <rect width="24.047" height="27.389" fill="none"/>
                </clipPath>
              </defs>
              <g clip-path="url(#d)">
                <rect id="Rectangle_81" data-name="Rectangle 81" width="4.665" height="25.889" transform="translate(0.75 0.75)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                <rect id="Rectangle_82" data-name="Rectangle 82" width="4.665" height="19.437" transform="translate(10.08 6.827)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                <rect id="Rectangle_83" data-name="Rectangle 83" width="4.665" height="13.217" transform="translate(18.632 13.047)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
              </g>
            </svg>
          </medium-button>
        </b-col>
      </b-row>
    </b-col>
    <b-col xl="10" lg="12" order="1" order-xl="2">
      <b-row>
        <b-col v-if="current_scalable_orders_value.length > 1" style="display: none;" :class="{ active: isConsolidated }">
          <highcharts :options="consolidatedChartOptions"></highcharts>
        </b-col>
        <b-col v-if="current_daily_sales.length > 1" style="display: none;" :class="{ active: isDaily }">
          <highcharts :options="dailyChartOptions"></highcharts>
        </b-col>
        <b-col v-if="monthly_sales_by_year.length > 1" style="display: none;" :class="{ active: isMonthly }">
          <highcharts :options="monthlyChartOptions"></highcharts>
        </b-col>
        <b-col v-if="channels_data.length > 1" style="display: none;" :class="{ active: isChannel }">
          <highcharts :options="channelsChartOptions"></highcharts>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
  <loader-box v-else height="400px" class="ml-2 mr-2"/>
</template>

<script>
import Highcharts from 'highcharts'
import VueHighcharts from 'highcharts-vue'
import MediumButton from '@/components/MediumButton.vue'
import LoaderBox from '@/components/LoaderBox.vue'

export default {
  data: () => ({
    isConsolidated: true,
    isDaily: false,
    isMonthly: false,
    isChannel: false
  }),
  methods: {
    toogleChart(chart) {
      this.isConsolidated = false;
      this.isDaily = false;
      this.isMonthly = false;
      this.isChannel = false;
      switch (chart) {
        case 'consolidated':
          this.isConsolidated = true;
          break;
        case 'daily':
          this.isDaily = true;
          break;
        case 'monthly':
          this.isMonthly = true;
          break;
        case 'channel':
          this.isChannel = true;
          break;
      }
    }
  },
  components: {
    MediumButton,
    LoaderBox
  },
  computed: {
    sales_products_context_loaded() { return this.$store.getters.sales_products_context_loaded },
    current_month_name() { return this.$store.getters.current_month_name },
    previous_month_name() { return this.$store.getters.previous_month_name },
    past_month_scalable_orders_value() { return this.$store.getters.past_month_scalable_orders_value },
    current_scalable_orders_value() { return this.$store.getters.current_scalable_orders_value },
    past_month_daily_sales() { return this.$store.getters.past_month_daily_sales },
    current_daily_sales() { return this.$store.getters.current_daily_sales },
    monthly_sales_by_year() { return this.$store.getters.monthly_sales_by_year },
    monthly_sales_qtd() { return this.$store.getters.monthly_sales_qtd },
    channels_data() { return this.$store.getters.channels_data },

    consolidatedChartOptions() {
      const pastMonthScalableOrdersValue = this.past_month_scalable_orders_value;
      const currentScalableOrdersValue = this.current_scalable_orders_value;
      const currentMonthName = this.current_month_name;
      const previousMonthName = this.previous_month_name;

      return {
        chart: {
          type: 'area'
        },
        title: {
          text: 'valor total em pedidos'
        },
        subtitle: {
          text: 'pedidos pagos'
        },
        xAxis: {
          allowDecimals: false,
          labels: {
            format: 'dia {value}'
          }
        },
        yAxis: {
          title: {
            text: 'valor em reais'
          },
          labels: {
            formatter: function () {
              return this.value / 1000 + 'k';
            }
          }
        },
        tooltip: {
          headerFormat: null,
          formatter: function() {
            return 'Dia ' + this.x + ' de ' + this.series.name + ':<br/>R$ ' + Highcharts.numberFormat(this.y, 2, ',', '.');
          }
        },
        plotOptions: {
          area: {
            pointStart: 1,
            marker: {
              radius: 3
            }
          }
        },
        series: [{
          name: previousMonthName,
          data: pastMonthScalableOrdersValue
        }, {
          name: currentMonthName,
          data: currentScalableOrdersValue
        }],
        colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"]
      }
    },
    dailyChartOptions() {
      const pastMonthDailySales = this.past_month_daily_sales;
      const currentDailySales = this.current_daily_sales;
      const currentMonthName = this.current_month_name;
      const previousMonthName = this.previous_month_name;

      return {
        chart: {
          type: 'area'
        },
        title: {
          text: 'pedidos diários'
        },
        subtitle: {
          text: 'pedidos pagos'
        },
        xAxis: {
          allowDecimals: false,
          labels: {
            format: 'dia {value}'
          }
        },
        yAxis: {
          title: {
            text: 'valor em reais'
          },
          labels: {
            formatter: function () {
              return this.value / 1000 + 'k';
            }
          }
        },
        tooltip: {
          headerFormat: null,
          formatter: function() {
            return 'Dia ' + this.x + ' de ' + this.series.name + ':<br/>R$ ' + Highcharts.numberFormat(this.y, 2, ',', '.');
          }
        },
        plotOptions: {
          area: {
            pointStart: 1,
            marker: {
              radius: 3
            }
          }
        },
        series: [{
          name: previousMonthName,
          data: pastMonthDailySales
        }, {
          name: currentMonthName,
          data: currentDailySales
        }],
        colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"]
      }
    },
    monthlyChartOptions() {
      const monthlySales = this.monthly_sales_by_year;
      const monthlySalesQtd = this.monthly_sales_qtd;
      const monthNames = [
        "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
      ];

      return {
        chart: {
          type: 'area'
        },
        title: {
          text: 'pedidos mensais'
        },
        subtitle: {
          text: 'pedidos pagos'
        },
        xAxis: {
          allowDecimals: false,
          labels: {
            formatter: function() {
              return monthNames[this.value - 1]
            }
          }
        },
        yAxis: {
          title: {
            text: 'valor em reais'
          },
          labels: {
            formatter: function () {
              return this.value / 1000 + 'k';
            }
          }
        },
        tooltip: {
          headerFormat: null,
          formatter: function() {
            return monthNames[this.x - 1] + ' de ' + this.series.name +
              ':<br/>R$ ' + Highcharts.numberFormat(this.y, 2, ',', '.') +
              '<br/>' + monthlySalesQtd[this.series.name][this.key - 1] + ' pedidos';
          }
        },
        plotOptions: {
          area: {
            pointStart: 1,
            marker: {
              radius: 3
            }
          }
        },
        series: monthlySales,
        colors: ['#7cb5ec', '#434348', '#90ed7d', '#f7a35c', '#8085e9', '#f15c80', '#e4d354', '#2b908f', '#f45b5b', '#91e8e1']
      }
    },
    channelsChartOptions() {
      const channelsData = this.channels_data;
      const drilldownSeries = this.$store.getters.drilldown_series;

      return {
        chart: {
          type: 'pie'
        },
        title: {
          text: 'pedidos por canal'
        },
        subtitle: {
          text: 'clique para ver detalhes'
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: '{point.name}: {point.percentage:.1f}%'
            }
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> do total<br/>'
        },
        series: [{
          name: 'Canais',
          colorByPoint: true,
          data: channelsData
        }],
        drilldown: {
          series: drilldownSeries
        }
      }
    }
  }
}
</script>

<style scoped>
  .active {
    display: block !important
  }
</style>
